export const TxTypes = [
  { id: 1, name: 'Ввод в эксплуатацию' },
  { id: 2, name: 'Перемещение' },
  { id: 3, name: 'Установка' },
  { id: 4, name: 'Снятие' },
  { id: 5, name: 'Корректировка' },
  { id: 6, name: 'Списание' },
];

export const TX_TYPE_COMMISSIONING = TxTypes[0];
export const TX_TYPE_MOVING = TxTypes[1];
export const TX_TYPE_INSTALLING = TxTypes[2];
export const TX_TYPE_REMOVAL = TxTypes[3];
export const TX_TYPE_CORRECTION = TxTypes[4];
export const TX_TYPE_DECOMMISSIONING = TxTypes[5];